import { useTranslation } from "react-i18next";
import { PAUSES } from "../../../config/constants";
import { cx } from "../cx";
import type { PauseCueKind } from "../keys";

/** "Pause · kurz" between two Blocks; the title carries the seconds of silence the stitcher inserts. */
export function PauseCueChip({ kind, className = "" }: { kind: PauseCueKind; className?: string }) {
  const { t } = useTranslation("components");
  return (
    <span
      data-component="PauseCueChip"
      data-kind={kind}
      title={t("pause.seconds", { seconds: PAUSES[kind] })}
      className={cx(
        "inline-flex h-[20px] items-center rounded-sm border border-line bg-ground px-1.5 font-mono text-label text-ink-2",
        className,
      )}
    >
      {t("pause.label")} · {t(`pause.kind.${kind}`)}
    </span>
  );
}
